<template>
  <el-row style="padding: 20px" :gutter="20">
    <el-container>
      <el-main style="padding: 0; background-color: white">
        <el-col :span="8" style="display: flex; align-items: center;">
          <label style="width: 100px">关键词：</label>
          <el-input
              v-model="filters.key"
              placeholder="请输入关键词"
              clearable
              @input="search(filters.key)"
          >
          </el-input>
        </el-col>
        <el-col :span="8" style="display: flex; align-items: center;">
          <label style="width: 100px">状态：</label>
          <el-select v-model="filters.status" placeholder="请选择状态" clearable @change="statusChange($event)">
            <el-option label="未开始" :value=0></el-option>
            <el-option label="进行中" :value=1></el-option>
            <el-option label="已结束" :value=2></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-button @click="handleAdd" type="primary" icon="el-icon-plus">新增</el-button>
        </el-col>
        <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; margin-top: 20px;"
            v-loading="tableDataLoading"
        >
          <el-table-column prop="name" label="活动名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column>
          <el-table-column prop="type" label="类型" :formatter="formatType"></el-table-column>
          <el-table-column prop="threshold" label="使用门槛"></el-table-column>
          <el-table-column prop="discountAmount" label="优惠额度" :formatter="formatDiscount"></el-table-column>
          <el-table-column prop="applicableProductList" label="适用商品"
                           :formatter="formatApplicableProductList"></el-table-column>
          <el-table-column prop="rules" label="规则"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" :formatter="formatStartTime"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" :formatter="formatEndTime"></el-table-column>
          <el-table-column label="领取情况">
            <template slot-scope="scope">
              {{ scope.row.received }} / {{ scope.row.totals }}
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
          >
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row)" type="text" size="small" v-if="scope.row.status !== 2">编辑
              </el-button>
              <el-button @click="showQrCode(scope.row)" type="text" size="small" v-if="scope.row.status !== 2">分享
              </el-button>
              <el-button v-if="scope.row.status === 0 && scope.row.received === 0"
                         @click="handleDelete(scope.row)"
                         type="text" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer style="background-color: white">
        <el-col :span="24">
          <el-pagination
              @size-change="handlePageSizeChange"
              @current-change="handleCurrentPageChange"
              :current-page="pageInfo.current"
              :page-sizes="[10, 50, 100]"
              :page-size="pageInfo.size"
              layout="sizes, prev, pager, next, total"
              :total="pageInfo.total">
          </el-pagination>
        </el-col>
      </el-footer>
    </el-container>
    <!-- 二维码对话框 -->
    <el-dialog :visible.sync="qrCodeVisible" title="分享二维码" width="300px">
      <VueQrcode :text="qrCodeValue"></VueQrcode>
    </el-dialog>
    <!-- 新增或编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="500px"
               @close="initDialog('form')" :before-close="handleDialogClose">
      <div
          style="max-height: 400px; overflow-y: auto; overflow-x: hidden; scrollbar-width: thin; scrollbar-color: #888 transparent;">
        <el-form :model="form" :rules="rules" ref="form" style="margin-right: 10px; margin-left: 10px">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="form.name" :disabled="editable" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="selectedOption" :disabled="editable" placeholder="请选择类型">
              <el-option label="打折(满使用门槛打优惠额度折,如满200打8折)" :value=0></el-option>
              <!--            <el-option label="满减(满使用门槛减优惠额度,如满200减20)" :value=1></el-option>-->
            </el-select>
          </el-form-item>
          <el-form-item label="适用商品" prop="applicableProductList">
            <el-select v-model="form.applicableProductList" multiple :disabled="editable" placeholder="请选择适用商品">
              <el-option
                  v-for="item in categories"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用门槛(0表示无门槛)" prop="threshold">
            <el-input v-model="form.threshold" :disabled="editable" placeholder="请输入使用门槛"></el-input>
          </el-form-item>
          <el-form-item :label="discountAmountLabel" prop="discountAmount">
            <el-input v-model="form.discountAmount" :disabled="editable" placeholder="请输入优惠额度"></el-input>
          </el-form-item>
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
                v-model="form.startTime" type="date" placeholder="请选择开始时间"
                style="width: 440px" :disabled="editable" @change="updateEndTimeOptions"
                :picker-options="startTimeOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
                v-model="form.endTime" type="date" placeholder="请选择结束时间"
                style="width: 440px" @change="updateStartTimeOptions"
                :picker-options="endTimeOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="规则" prop="rules">
            <el-input type="textarea" v-model="form.rules" :disabled="editable" placeholder="请输入规则"></el-input>
          </el-form-item>
          <el-form-item label="优惠券总数" prop="totals">
            <el-input v-model="form.totals" placeholder="请输入优惠券总数"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import VueQrcode from 'vue-qrcode-component';

export default {
  name: 'PromotionsManagement',
  components: {
    VueQrcode,
  },
  data() {
    return {
      // 搜索
      filters: {
        key: '',
        status: '',
      },
      // 表格数据
      tableData: [],
      // 表格数据加载
      tableDataLoading: true,
      // 对话框的显示状态
      dialogFormVisible: false,
      // 表单数据
      form: {
        id: '',
        name: '',
        status: '',
        applicableProductList: [],
        discountAmount: '',
        type: '',
        threshold: '',
        startTime: '',
        endTime: '',
        totals: '',
        received: '',
        rules: '',
      },
      // 优惠券数据结构
      promotion: {
        id: '',
        name: '',
        status: '',
        applicableProductList: [],
        discountAmount: '',
        type: '',
        threshold: '',
        startTime: '',
        endTime: '',
        totals: '',
        received: '',
        rules: '',
      },
      dialogTitle: '',
      editable: false,
      rules: {
        applicableProductList: [
          {required: true, message: '请选择适用商品', trigger: ['change', 'blur']},
        ],
        rules: [
          {required: true, message: '请输入规则', trigger: ['change', 'blur']},
        ],
        name: [
          {required: true, message: '请输入活动名称', trigger: ['change', 'blur']},
        ],
        discountAmount: [
          {required: true, message: '请输入优惠额度', trigger: ['change', 'blur']},
          {
            validator: (rule, value, callback) => {
              if (isNaN(value) || value <= 0) {
                callback(new Error('优惠额度必须为大于0的数字'));
              } else {
                callback();
              }
            },
          }
        ],
        type: [
          {required: true, message: '请选择类型', trigger: ['change', 'blur']},
        ],
        threshold: [
          {required: true, message: '请输入使用门槛', trigger: ['change', 'blur']},
          {
            validator: (rule, value, callback) => {
              if (isNaN(value) || value < 0) {
                callback(new Error('使用门槛必须为大于等于0的数字'));
              } else {
                callback();
              }
            }
          }
        ],
        startTime: [
          {required: true, message: '请选择开始时间', trigger: ['change', 'blur']},
        ],
        endTime: [
          {required: true, message: '请选择结束时间', trigger: ['change', 'blur']},
        ],
        totals: [
          {required: true, message: '请输入优惠券总数', trigger: ['change', 'blur']},
          {
            validator: (rule, value, callback) => {
              if (!/^\d+$/.test(value) || value <= 0) {
                callback(new Error('优惠券总数必须为大于0的整数'));
              } else {
                callback();
              }
            }
          }
        ],
      },
      startTimeOptions: {},
      endTimeOptions: {},
      //商品类别
      categories: [],
      // 分页信息
      pageInfo: {
        // 分页信息
        current: 1,
        size: 10,
        total: 1,
      },
      // 二维码
      qrCodeVisible: false,
      qrCodeValue: '',
    };
  },
  computed: {
    selectedOption: {
      get() {
        switch (this.form.type) {
          case 0:
            return '打折';
          case 1:
            return '满减';
          default:
            return '';
        }
      },
      set(value) {
        this.form.type = value;
      }
    },
    discountAmountLabel() {
      // 根据 type 的值返回不同的标签文本
      switch (this.form.type) {
        case 0:
          return '优惠额度(请输入0到1之间的数)'; // 当 type 为 0 时
        case 1:
          return '优惠额度(请输入具体减免金额)'; // 当 type 为 1 时
        default:
          return '优惠额度'; // 默认情况
      }
    },
  },
  created() {
    this.initPageData();
  },
  methods: {
    //初始化页面数据
    async initPageData() {
      await this.getProductCategories();
      this.getTableData();
    },
    //初始化对话框
    initDialog(formName) {
      this.$refs[formName].resetFields();
      this.form = Object.assign({}, this.promotion);
      this.startTimeOptions = {};
      this.endTimeOptions = {};
      // console.log("关闭对话框，初始化对话框");
    },
    //获取类别
    getProductCategories() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch("Product/getProductCategories")
            .then((res) => {
              // console.log(res);
              this.categories = res.data.data;
              // if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              //   console.log(res);
              // }
              resolve("商品类别加载成功！");
            })
            .catch(() => {
              reject("商品列表加载失败！");
            });
      });
    },
    // 获取表格数据
    getTableData(page = this.pageInfo.current, size = this.pageInfo.size, status = this.filters.status,
                 key = this.filters.key) {
      this.$store.dispatch("Promotions/getAllPromotions", {
        page: page, size: size,
        status: status, input: key
      })
          .then((res) => {
            this.tableData = res.data.data.list;
            this.pageInfo.total = res.data.data.totalCount;
            this.tableDataLoading = false;
          })
          .catch((err) => {
            console.log(err)
          });
    },
    formatStatus(row) {
      const status = row.status;
      return status === 0 ? '未开始' : status === 1 ? '进行中' : status === 2 ? '已结束' : '';
    },
    formatType(row) {
      const type = row.type;
      return type === 0 ? '打折' : type === 1 ? '满减' : '';
    },
    formatDiscount(row) {
      const discount = row.discountAmount;
      if (discount > 0 && discount < 1) {
        return `${discount * 10}折`;
      }
      return discount;
    },
    formatApplicableProductList(row) {
      const names = row.applicableProductList.map(id => {
        const category = this.categories.find(category => category.id === id);
        return category ? category.title : id;
      });
      return names.join(',');
    },
    formatStartTime(row) {
      const date = new Date(row.startTime);
      // const options = {
      //   year: 'numeric',
      //   month: '2-digit',
      //   day: '2-digit',
      //   hour: '2-digit',
      //   minute: '2-digit',
      //   second: '2-digit',
      //   hour12: false
      // };
      // return new Intl.DateTimeFormat('zh-CN', options).format(date);
      return date.toISOString().substring(0, 10);
    },
    formatEndTime(row) {
      const date = new Date(row.endTime);
      // const options = {
      //   year: 'numeric',
      //   month: '2-digit',
      //   day: '2-digit',
      //   hour: '2-digit',
      //   minute: '2-digit',
      //   second: '2-digit',
      //   hour12: false
      // };
      // return new Intl.DateTimeFormat('zh-CN', options).format(date);
      return date.toISOString().substring(0, 10);
    },
    // 分页切换当前页码时调用
    handleCurrentPageChange(currentPage) {
      this.pageInfo.current = currentPage;
      this.getTableData(this.pageInfo.current, this.pageInfo.size, this.filters.status, this.filters.key);
    },
    // 分页尺寸更换时候调用
    handlePageSizeChange(pageSize) {
      console.log('分页尺寸更换')
      this.pageInfo.current = 1;
      this.pageInfo.size = pageSize;
      this.getTableData(this.pageInfo.current, this.pageInfo.size, this.filters.status, this.filters.key);
    },
    search(key) {
      this.getTableData(this.pageInfo.current, this.pageInfo.size, this.filters.status, key);
    },
    statusChange(value) {
      this.getTableData(this.pageInfo.current, this.pageInfo.size, value, this.filters.key);
    },
    // 重置按钮
    // resetFilters() {
    //   this.filters.text = '';
    //   this.filters.status = '';
    // },
    // 新增
    handleAdd() {
      this.dialogTitle = '新增'; // 设置标题为 '新增'
      this.editable = false;
      // this.form = Object.assign({}, this.promotion); // 清空表单
      this.dialogFormVisible = true; // 打开对话框
    },
    // 编辑
    handleEdit(row) {
      this.form = Object.assign({}, row);
      if (row.status === 0 && row.received === 0) {
        // 如果活动未开始且没有领取，允许修改所有字段
        this.editable = false;
      } else if ((row.status === 0 && row.received !== 0) || row.status === 1) {
        // 如果活动未开始但有领取或活动进行中，只允许修改结束时间和领取限制
        this.editable = true;
        this.updateEndTimeOptions(this.form.startTime);
      }
      this.dialogTitle = '编辑'; // 设置标题为 '编辑'
      this.dialogFormVisible = true; // 打开对话框
    },
    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            // console.log('编辑', this.form);
            this.$store.dispatch("Promotions/editPromotion", this.form)
                .then(() => {
                  this.$message({
                    type: 'success',
                    message: '编辑成功!'
                  });
                  this.getTableData(this.pageInfo.current, this.pageInfo.size);
                  this.dialogFormVisible = false; // 关闭对话框
                })
                .catch((err) => {
                  this.$message({
                    type: 'error',
                    message: err.response.data.message
                  });
                });
          } else {
            const data = {
              name: this.form.name,
              applicableProductList: this.form.applicableProductList,
              discountAmount: this.form.discountAmount,
              type: this.form.type,
              threshold: this.form.threshold,
              startTime: this.form.startTime,
              endTime: this.form.endTime,
              totals: this.form.totals,
              rules: this.form.rules,
            };
            // Format the dates to 'YYYY-MM-DD'
            const formatDate = (date) => {
              const d = new Date(date);
              const year = d.getFullYear();
              const month = String(d.getMonth() + 1).padStart(2, '0');
              const day = String(d.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            };
            data.startTime = formatDate(data.startTime);
            data.endTime = formatDate(data.endTime);
            this.$store.dispatch("Promotions/addPromotion", data)
                .then((res) => {
                  console.log(res);
                  this.$message({
                    type: 'success',
                    message: '新增成功!'
                  });
                  this.getTableData(this.pageInfo.current, this.pageInfo.size);
                  this.dialogFormVisible = false; // 关闭对话框
                })
                .catch((err) => {
                  console.log(err.response.data);
                  this.$message({
                    type: 'error',
                    message: err.response.data.message
                  });
                });
          }
          // this.dialogFormVisible = false; // 关闭对话框
          // this.$refs['form'].resetFields(); // 重置表单验证状态
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    updateEndTimeOptions(value) {
      // 更新结束时间的可选项
      this.endTimeOptions = {
        disabledDate(time) {
          if (value) {
            return time.getTime() < new Date(value).getTime();
          }
          return false;
        },
      }
    },
    updateStartTimeOptions(value) {
      // 更新开始时间的可选项
      this.startTimeOptions = {
        disabledDate(time) {
          if (value) {
            return time.getTime() > new Date(value).getTime();
          }
          return false;
        }
      }
    },
    //处理意外退出的情况
    handleDialogClose(done) {
      this.$confirm("操作未保存，是否退出？")
          .then(() => {
            // this.$refs['form'].resetFields();
            done();
          })
          .catch(() => {
            // this.$refs['form'].resetFields();
          });
    },
    handleDelete(row) {
      console.log('删除', row);
      this.$confirm('此操作将永久删除该活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch("Promotions/deletePromotion", {id: row.id})
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getTableData(this.pageInfo.current, this.pageInfo.size);
            })
            .catch((err) => {
              console.log(err);
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    showQrCode(row) {
      console.log(row.id)
      this.qrCodeValue = `https://zdshop.mdline.cn:9091?id=${row.id}`;
      this.qrCodeVisible = true;
    },
  },
};
</script>

<style scoped>
</style>
